export const formatTrendPercent = (trendPercent) => {
  if (trendPercent == null || Number.isNaN(Number(trendPercent))) {
    return null;
  }

  const value = Number(trendPercent);
  let className = ' negative';
  if (value > 0) {
    className = '';
  } else if (value === 0) {
    className = ' flat';
  }

  return {
    label: `(${value > 0 ? '+' : ''}${value}%)`,
    className
  };
};

export const formatCount = (value) => {
  if (value == null || Number.isNaN(Number(value))) {
    return '0';
  }

  return new Intl.NumberFormat('en-GB', {
    maximumFractionDigits: 0
  }).format(Number(value));
};

export const formatCurrency = (value) => {
  if (value == null) return '$0';
  return `$${new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(Number(value))}`;
};

export const CASHBACK_HEALTHY_REDEEMS_THRESHOLD = 10;

export const getCashbackWidgetState = ({isEnrolled, redeemedOrdersTotal}) => {
  if (!isEnrolled) {
    return 'notEnrolled';
  }

  if (Number(redeemedOrdersTotal) >= CASHBACK_HEALTHY_REDEEMS_THRESHOLD) {
    return 'healthy';
  }

  return 'early';
};
